import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getPetitionCommentPageData } from './api';
import type { PetitionCommentPageDataErrorCode } from './types';

export const {
	Context: PetitionCommentPageDataContext,
	Provider: PetitionCommentPageDataContextProvider,
	useContext: usePetitionCommentPageData,
	useAsyncData: usePetitionCommentPageDataFromApi,
	prefetchAsyncData: prefetchPetitionCommentPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PetitionCommentPageDataContext',
	dataProperty: 'pageData',
	getData: getPetitionCommentPageData,
	getUniqueId: (slug, id) => [slug, id].join(':'),
	hasUserData: true, // for the viewerLiked value
	errorHandler: pageDataErrorHandler<PetitionCommentPageDataErrorCode>(),
});
